import { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getLineItemService } from '../../../../../../modules/services/lineItems'
import { setRightUploadAdData } from '../../../../../../modules/actions/rights'
import { selfAccountSelector } from '../../../../../../modules/selectors/selfAccounts'

import { GOOGLE_AD_MANAGER_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { GAM_NETWORK_CODE } from '../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'

const useSubmitExistingLineItem = ({ setSuccessSubmit }) => {
  const dispatch = useDispatch()
  const [isExistingLoading, setIsExistingLoading] = useState(false)
  const [isExistingError, setIsExistingError] = useState(null)

  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const handleExistedLineItemSubmit = useCallback(
    async selectedLineItemId => {
      try {
        setIsExistingLoading(true)
        const selectedLineItemFullData = await getLineItemService(GOOGLE_AD_MANAGER_PLATFORM, {
          id: selectedLineItemId,
          network_code: gamNetworkCode
        })

        dispatch(setRightUploadAdData({ lineItem: selectedLineItemFullData }, GOOGLE_AD_MANAGER_PLATFORM))
        setIsExistingLoading(false)
        setSuccessSubmit(true)
      } catch (error) {
        // Handle error gracefully (log for diagnostics)
        // You might also want to surface a user-friendly error via a toast/notification system
        // or dispatch an action to store error state if available in your app.
        // For now, we log it to keep the flow resilient.
        // eslint-disable-next-line no-console
        console.error('Failed to apply uploaded ad data for line items', error)
        setIsExistingError(error)
      } finally {
        setIsExistingLoading(false)
      }
    },
    [dispatch, gamNetworkCode, setSuccessSubmit]
  )

  return useMemo(
    () => ({
      isExistingLoading,
      isExistingError,
      handleExistedLineItemSubmit
    }),
    [handleExistedLineItemSubmit, isExistingError, isExistingLoading]
  )
}

export default useSubmitExistingLineItem
